





















































































































































































import Vue from 'vue'

import ExcLoader from '@/components/common/svg/ExcLoader.vue'
import { sizeValidator, defaultSize } from '@/lib/utils'
import ExcDropdownTriangle from '../svg/ExcDropdownTriangle.vue'

interface Column {
  value: string;
  hideOnMobile?: boolean;
}

interface Row {
  [key: string]: boolean;
}

const headingFormatChecker = (headers: string[] | Column) => {
  if (Array.isArray(headers)) return true
  return Object.values(headers).every(
    header => header.toString() === header || 'value' in header,
  )
}

const DESC = 'DESC'
const ASC = 'ASC'

export default Vue.extend({
  name: 'TdxTable',
  components: {
    ExcLoader,
    ExcDropdownTriangle,
  },
  props: {
    heading: {
      type: [Array, Object],
      required: true,
      validator: headingFormatChecker,
    },
    sorting: {
      // keys same as row names and values as direction or true
      type: Object,
      default: () => ({}),
    },
    rows: { type: Array, required: true },
    emptyMessage: { type: String, default: '' },
    animated: { type: Boolean, default: false },
    loading: { type: Boolean, default: false },
    tableTitle: { type: String, default: '' },
    activeRow: {
      type: Object,
      default: () => ({}),
    },
    adaptive: { type: Boolean, default: false }, // if ftrue will change table view for mobile devices, if false table will not change on mobiles
    cellSize: { validator: sizeValidator, default: defaultSize },
    cellWidth: { validator: sizeValidator, default: defaultSize },
    lessTitle: {
      type: String,
      default: 'less',
    },
    moreTitle: {
      type: String,
      default: 'more',
    },
  },
  data () {
    return {
      isVisible: {} as Row,
      DESC,
      ASC,
      specifiedSorting: {} as any,
    }
  },
  computed: {
    showMobileToggle (): boolean {
      return (
        Object.values(this.heading).filter((head: any) => !head.hideOnMobile).length >= 6 &&
        this.adaptive
      )
    },
    wrapperClasses () {
      return {
        'tdx-table__container--adaptive': this.adaptive,
      }
    },
    classes (): { [key: string]: boolean } {
      return {
        'tdx-table--adaptive': this.adaptive,
        'tdx-table--show-row-toggle': this.showMobileToggle,
        [`tdx-table--width-${this.cellWidth}`]: this.cellWidth,
      }
    },
    cellSizeClass () {
      return {
        'tdx-table--xl pt-4 pb-4': this.cellSize === 'xl',
        'tdx-table--l pt-10 pb-10': this.cellSize === 'l',
        'tdx-table--m pt-10 pb-10': this.cellSize === 'm',
        'tdx-table--s pt-10 pb-10': this.cellSize === 's',
        'tdx-table--xs pt-10 pb-10': this.cellSize === 'xs',
      }
    },
    firstColumnName () {
      return Array.isArray(this.heading) ? 0 : Object.keys(this.heading)[0]
    },
  },
  mounted () {
    setTimeout(() => {
      (this.$refs.table as HTMLHtmlElement).addEventListener(
        'scroll',
        this.onScrollToBottom,
      )
    })

    // check values
    const valuesIsOk = Object.values(this.sorting).every(s => !!s)
    if (!valuesIsOk) {
      throw new Error(
        'Initial values for sorting should be true or "ASC" | "DESC"',
      )
    }

    // only one sorting per table
    const valSpecified = Object.values(this.sorting).filter(
      s => typeof s === 'string',
    ).length
    if (valSpecified > 1) throw new Error('No more then one sorting allowed.')

    // assign initial sorting
    Object.keys(this.sorting).forEach((k) => {
      if (typeof this.sorting[k] === 'string') {
        this.specifiedSorting[k] = this.sorting[k]
      }
    })
    this.specifiedSorting = { ...this.specifiedSorting }
  },
  beforeDestroy () {
    (this.$refs.table as HTMLHtmlElement).removeEventListener(
      'scroll',
      this.onScrollToBottom,
    )
  },
  methods: {
    onClickTh (ind: number | string) {
      // set new sorting
      if (!this.specifiedSorting[ind] || this.specifiedSorting[ind] === ASC) {
        this.specifiedSorting = {}
        this.specifiedSorting[ind] = DESC
      } else if (this.specifiedSorting[ind] === DESC) {
        this.specifiedSorting = {}
        this.specifiedSorting[ind] = ASC
      } else {
        // not remove sorting yet
        // this.specifiedSorting = {}
      }

      // apply reactivity
      this.specifiedSorting = { ...this.specifiedSorting }

      this.$emit('sort', this.specifiedSorting)
    },
    toggleAllOptionsVisibility (rowIndex: number) {
      this.isVisible = {
        ...this.isVisible,
        [`row${rowIndex}`]: !this.isVisible[`row${rowIndex}`],
      }
    },
    onScrollToBottom (e: any) {
      if (
        e.target.scrollTop + e.target.clientHeight >= e.target.scrollHeight &&
        !this.loading
      ) {
        this.$emit('scroll-to-bottom')
      }
    },
    compColumnValue (col: string | Column) {
      if (col instanceof Object) return col.value
      return col
    },
  },
})
